export class BatchNotFoundError extends Error {}
